import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PublicSharedReportPage from './PublicSharedReportPage';
import ShareUnsubscribePage from './ShareUnsubscribePage';

const NotFound = () => (
  <div style={{
    minHeight: '100vh',
    background: '#f5f7fb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Montserrat, Inter, system-ui, sans-serif',
    color: '#1e272e',
  }}>
    <div style={{ maxWidth: 480, padding: 32, background: '#fff', borderRadius: 12, textAlign: 'center' }}>
      <h2 style={{ marginTop: 0, color: '#0784a7' }}>Link not found</h2>
      <p style={{ color: '#4a5560' }}>The share link you used isn't recognised. It may have been mistyped.</p>
      <p style={{ marginTop: 24 }}>
        <a href='https://askmultiply.com' style={{ color: '#0784a7', fontWeight: 600 }}>Learn about Multiply</a>
      </p>
    </div>
  </div>
);

const PublicShareLayout = () => (
  <BrowserRouter>
    <Switch>
      <Route path='/share/unsubscribe-confirm' component={ShareUnsubscribePage} />
      <Route path='/share/:shareToken' component={PublicSharedReportPage} />
      <Route component={NotFound} />
    </Switch>
  </BrowserRouter>
);

export default PublicShareLayout;
